import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import AiAgents from "@/pages/AiAgents";
import ConversationalAI from "@/pages/ConversationalAI";
import Work from "@/pages/Work";
import WorkDetail from "@/pages/WorkDetail";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import NotFound from "@/pages/NotFound";

function App() {
    return (
        <BrowserRouter>
            <Routes>
                <Route element={<Layout />}>
                    <Route path="/" element={<Home />} />
                    <Route path="/ai-agents" element={<AiAgents />} />
                    <Route
                        path="/conversational-ai"
                        element={<ConversationalAI />}
                    />
                    <Route path="/work" element={<Work />} />
                    <Route path="/work/:slug" element={<WorkDetail />} />
                    <Route path="/about" element={<About />} />
                    <Route path="/contact" element={<Contact />} />
                    <Route path="*" element={<NotFound />} />
                </Route>
            </Routes>
        </BrowserRouter>
    );
}

export default App;
